import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/Logo.svg';
import instaLogo from '../assets/instagram.svg';
import fbLogo from '../assets/facebook2.svg';
import tiktokLogo from '../assets/icon_tiktok.svg';
import discordLogo from '../assets/discord.svg';
import ldLogo from '../assets/linkedin2.svg';

type NavbarProps = {
  backgroundScrollOff: () => void;
};

const Navbar = (props: NavbarProps, ref: React.LegacyRef<HTMLElement>): JSX.Element => {
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    if (document && document.getElementById('burger') && (document.getElementById('burger') as HTMLInputElement).checked)
      document.getElementById('burger')?.click();
  }, [location]);

  //if (path.startsWith('/v/')) return <div style={{ display: 'none' }} />;

  return (
    <nav ref={ref} className='navContainer'>
      <nav className='navSubContainer'>
        {/* <div className='store'>
          <a href='about:blank' target='_blank' rel='noreferrer'>
            <img src={appStore} alt='app-store-logo' />
          </a>
          <a href='about:blank' target='_blank' rel='noreferrer'>
            <img src={playStore} alt='play-store-logo' />
          </a>
        </div> */}
        <Link className='image' to='/'>
          <img src={logo} alt='squib-logo' />
        </Link>
        <input type='checkbox' onChange={props.backgroundScrollOff} id='burger' hidden />
        <label htmlFor='burger' className='bars'>
          <span className='singleBar'></span>
        </label>
        {/* <div className='social desktop'>
          <a href='https://www.instagram.com/squib.app/' target='_blank' rel='noreferrer'>
            <img style={{ marginLeft: '0' }} src={instaLogo} alt='insta-logo' />
          </a>
          <a href='https://www.tiktok.com/@squib.app' target='_blank' rel='noreferrer'>
            <img src={tiktokLogo} alt='fb-logo' />
          </a>
          <a href='https://www.facebook.com/Squib-375471659967645' target='_blank' rel='noreferrer'>
            <img src={fbLogo} alt='fb-logo' />
          </a>
          <a href='https://discord.gg/V6N7YNrHXV' target='_blank' rel='noreferrer'>
            <img src={discordLogo} alt='discord-logo' />
          </a>
          <a href='https://www.linkedin.com/company/squib-solutions' target='_blank' rel='noreferrer'>
            <img src={ldLogo} alt='linkedin-logo' />
          </a>
        </div> */}
        <div className='mobileMenu'>
          <div className='mobileLinks'>
            <div className='headerPageLinks'>
              <Link style={{ paddingTop: '-7.5px' }} to='/voting'>
                VOTING ERSTELLEN
              </Link>
              <div className='splitLine'></div>
              <Link to='/mobile-app'>ÜBER SQUIB</Link>
              <Link to='/blog'>BLOG</Link>
              <Link to='/kontakt'>KONTAKT</Link>
              <Link to='/jobs'>JOBS</Link>
              <Link to='/media'>MEDIEN</Link>
              <Link to='/impressum-datenschutz'>IMPRESSUM</Link>
              {/* <div className='splitLine'></div> */}
            </div>
          </div>
          {/* <div className='languageContainer'>
              <p className='language'>DEUTSCH</p>
              <div>
                <img src={arrowDown} alt='arrow' />
              </div>
            </div> */}
          <div className='mobileFooter'>
            <div className='social'>
              <a href='https://www.instagram.com/squib.app/'>
                <img style={{ marginLeft: '0' }} src={instaLogo} alt='insta-logo' />
              </a>
              <a href='https://www.tiktok.com/@squib.app' target='_blank' rel='noreferrer'>
                <img src={tiktokLogo} alt='fb-logo' />
              </a>
              <a href='https://www.facebook.com/Squib-375471659967645'>
                <img src={fbLogo} alt='fb-logo' />
              </a>
              <a href='https://discord.gg/V6N7YNrHXV'>
                <img src={discordLogo} alt='discord-logo' />
              </a>
              <a href='https://www.linkedin.com/company/squib-solutions'>
                <img src={ldLogo} alt='linkedin-logo' />
              </a>
            </div>
            <p className='ltdSmall'>© 2022 Squib Ltd.</p>
            <p className='policy'>
              Squib ist eine urheberrechtlich geschützte Marke von Squib Ltd. Alle Rechte vorbehalten. Alle anderen Marken sind Eigentum der
              jeweiligen Inhaber.
            </p>
          </div>
        </div>
      </nav>
    </nav>
  );
};

const forwardedNavbar = forwardRef(Navbar);

export default forwardedNavbar;
